import { render, staticRenderFns } from "./DeeplTranslation.vue?vue&type=template&id=c45108fc&scoped=true&"
import script from "./DeeplTranslation.vue?vue&type=script&lang=js&"
export * from "./DeeplTranslation.vue?vue&type=script&lang=js&"
import style0 from "./DeeplTranslation.vue?vue&type=style&index=0&id=c45108fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45108fc",
  null
  
)

export default component.exports